var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaMonitorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GA_Monitor_Software-Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107 107",
    style: {
      enableBackground: "new 0 0 107 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:#007C00;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.8119,
    y1: -11353.1973,
    x2: 98.385,
    y2: -11353.1973,
    gradientTransform: "matrix(1 0 0 1 7.5575 11406.6973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0753,
    style: {
      stopColor: "#8EEE71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#9CEF7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5719,
    style: {
      stopColor: "#ADF090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    style: {
      stopColor: "#C7F1AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#D1F2B5"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    className: "st0",
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.2673,
    y1: 23.2824,
    x2: 104.009,
    y2: 37.7218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    style: {
      stopColor: "#3CB428"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1651,
    style: {
      stopColor: "#40B72B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2997,
    style: {
      stopColor: "#4BC136"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3041,
    style: {
      stopColor: "#4CC136"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#52C23D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6386,
    style: {
      stopColor: "#5CC146"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    style: {
      stopColor: "#6BBF54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9678,
    style: {
      stopColor: "#70BE59"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.07,11.5v25.81c-2.27,2.36-4.9,4.4-7.79,6.02c-3.39,1.9-7.19,2.86-10.93,3.91 c-11,3.09-21.6,9.19-33.15,10.2c-3.23,0.28-6.41-0.35-9.5-1.38c-3.92-1.3-7.71-3.24-11.32-4.77c-0.72,0.01-2-0.85-2.68-1.14 c-0.82-0.35-1.64-0.71-2.46-1.06c-1.89-0.82-3.78-1.63-5.66-2.45c-3.76-1.65-7.51-3.32-11.25-5.03c-2.14-0.98-4.27-1.96-6.4-2.95 V11.5c0-0.04,0.01-0.07,0.01-0.11c4.85,0.93,9.55,2.7,13.82,5.1c11.97,6.71,17,18.6,27.47,26.37c10.45,7.75,20.2-0.33,26.65-8.42 c5.47-6.85,11.86-13.39,19.23-18.41c4.4-3,8.96-4.87,13.85-5.78C104.02,10.65,104.07,11.07,104.07,11.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.1072,
    y1: 94.0277,
    x2: 126.9211,
    y2: 54.4479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#023D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2737,
    style: {
      stopColor: "#034201"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    style: {
      stopColor: "#075002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9278,
    style: {
      stopColor: "#0C6705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9531,
    style: {
      stopColor: "#0D6905"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.5,54.79v43.75c-0.87,2.28-2.68,4.09-4.96,4.96H8.46c-2.28-0.87-4.09-2.68-4.96-4.96V54.72 c0.87,0.61,45.92,2.91,50.63,2.9C57.96,57.61,103.5,54.79,103.5,54.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.454,
    y1: 106.5908,
    x2: 57.1571,
    y2: 60.9411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D7A06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1138,
    style: {
      stopColor: "#107D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2353,
    style: {
      stopColor: "#208D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    style: {
      stopColor: "#48B436"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8376,
    style: {
      stopColor: "#61CC4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AD551"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.95,99.68c0.47,1.47,0.97,2.92,1.44,4.39H33.5c4.64-14.19,9.29-29.22,10.03-34.58 c0.22-1.62-0.99-2.83-2.24-3.72c-1.52-1.07-3.19-1.93-4.75-2.92c-0.13-0.08-0.9-0.53-1.76-1.04c-1.31-0.78-2.85-1.73-2.81-1.89 c1.58,0.47,4.9,0.82,4.9,0.82c3.89,0.6,9.63,1.53,15.76,1.53c5.68,0,14.36-0.67,18.63-1.17c0.01,0-0.32,0.38-0.36,0.41 c-0.32,0.26-0.67,0.48-1.01,0.71c-0.08,0.05-0.15,0.1-0.23,0.15c-1.2,0.79-2.42,1.56-3.58,2.43c-0.94,0.71-2.85,2.02-2.73,3.4 c0.06,0.62,0.3,2.62,0.39,3.24c0.73,4.9,2.46,9.73,3.88,14.42C69.02,90.48,70.47,95.08,71.95,99.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.676,
    y1: 73.3799,
    x2: 111.8244,
    y2: 3.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#118502"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2474,
    style: {
      stopColor: "#138404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    style: {
      stopColor: "#188308"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5489,
    style: {
      stopColor: "#1E8610"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9355,
    style: {
      stopColor: "#318F26"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.07,32.14v20.17C102.94,52.83,81.14,62.5,53.5,62.5c-22.54,0-50.55-10.43-50.57-10.44l0-21.03 c0.49,0.11,0.97,0.22,1.47,0.35c9.17,2.47,16.01,6.35,24.12,11.21c6.26,3.75,11.67,9.29,18.83,11.35 c7.97,2.29,15.18-0.52,21.55-5.18c6.35-4.66,12.88-9.35,20.3-12.16C94.03,34.78,99.09,33.52,104.07,32.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.933,
    y1: 60.804,
    x2: 104.0668,
    y2: 60.804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8FEB73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2261,
    style: {
      stopColor: "#97FF77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2881,
    style: {
      stopColor: "#A1FF82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4052,
    style: {
      stopColor: "#B1FF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4655,
    style: {
      stopColor: "#ABFF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5663,
    style: {
      stopColor: "#A8FF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6739,
    style: {
      stopColor: "#BAFB9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    style: {
      stopColor: "#CDF7B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2F4B3"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.07,52.32v4.88c-8.16,4.14-21.26,10.6-40.55,12.35l-0.01-0.05c-0.81-3.99,1.04-7.49,5.08-7.91 c3.82-0.44,7.62-1.1,11.26-1.86c7.41-1.53,13.53-3.41,17.77-4.9c2.24-0.78,4.14-1.51,5.61-2.15 C103.68,52.49,103.96,52.37,104.07,52.32z M37.53,61.1c-0.01,0-0.04-0.01-0.06-0.01c-14.94-2.37-28.96-7.06-33.21-8.56 c-0.53-0.18-0.98-0.34-1.32-0.47v5c7.68,3.67,23.53,10.33,40.6,12.42c0.01-0.02,0.01-0.06,0.02-0.1 C44.47,65.32,41.66,61.64,37.53,61.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st6",
    d: "M95.5,3.5c4.42,0,8,3.58,8,8v84c0,4.42-3.58,8-8,8h-84c-4.42,0-8-3.58-8-8v-84 c0-4.42,3.58-8,8-8H95.5 M95.5,0h-84C5.16,0,0,5.16,0,11.5v84c0,6.34,5.16,11.5,11.5,11.5h84c6.34,0,11.5-5.16,11.5-11.5v-84 C107,5.16,101.84,0,95.5,0L95.5,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaMonitorLogo);
export default __webpack_public_path__ + "static/media/ga_monitor_logo.657c6c5391c871c348cf7ac770cdd1cb.svg";
export { ForwardRef as ReactComponent };